import logger from '../utils/logger';

/**
 * Security Headers Configuration for CSR (Client-Side Rendering)
 * Focus on client-side API request headers
 */

// Headers specifically for API requests (client-side)
export const getApiSecurityHeaders = () => {
  return {
    // No backend reads this. It is the legacy XHR marker some frameworks treat
    // as a CSRF signal; bearer-token auth needs no CSRF token.
    'X-Requested-With': 'XMLHttpRequest',
    
    // Content negotiation
    'Accept': 'application/json',
    
    // Request identification for security monitoring.
    // VITE_CACHE_VERSION is the real build id ("<pkg semver>-<buildTimestamp>"),
    // injected via vite.config.js `define`. The API's monitoring compares it for
    // its STALE/CURRENT verdict, and useVersionCheck reads the same value, so an
    // alert maps to a known deploy.
    'X-Client-Version': import.meta.env.VITE_CACHE_VERSION || '1.0.0',
    'X-Request-Source': 'web-client',
  };
};

// Validate security headers in API responses (for monitoring)
export const validateSecurityHeaders = (response) => {
  const requiredHeaders = [
    'X-Content-Type-Options',
    'X-Frame-Options',
    'Content-Security-Policy'
  ];
  
  const missingHeaders = requiredHeaders.filter(
    header => !response.headers[header.toLowerCase()]
  );
  
  if (missingHeaders.length > 0) {
    // warnOnce per distinct missing-header set: this runs on every API response,
    // so an un-deduped console.warn floods the dev console (~45×/page load).
    logger.warnOnce(
      `missing-security-headers:${missingHeaders.join(',')}`,
      '[Security] Missing security headers in API response:',
      missingHeaders,
      '— these should be set by your backend server',
    );
  }
  
  return missingHeaders.length === 0;
};

export default {
  getApiSecurityHeaders,
  validateSecurityHeaders,
};
